import React from "react";
import { useNavigate } from "react-router-dom";
import { Lock } from "lucide-react";
import "./FeatureGate.css";
import { useTranslation } from "../i18n/UseTranslation";

const PLAN_WEIGHTS = {
  none: -1,
  free: 0,
  essential: 1,
  business: 2,
  enterprise: 3,
};

export type PlanCode = keyof typeof PLAN_WEIGHTS;

interface FeatureGateProps {
  userPlan: PlanCode;
  requiredPlan: PlanCode;
  featureName?: string;
  minHeight?: number | string;
  children: React.ReactNode;
}

const FeatureGate: React.FC<FeatureGateProps> = ({
  userPlan,
  requiredPlan,
  featureName,
  minHeight = 420,
  children,
}) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const translations = t.featureGate;

  if (PLAN_WEIGHTS[userPlan] >= PLAN_WEIGHTS[requiredPlan]) {
    return <>{children}</>;
  }

  return (
    <div
      className="feature-gate-container"
      style={{ position: "relative", overflow: "hidden" }}
    >
      <div
        className="feature-blurred"
        style={{ filter: "blur(5px)", opacity: 0.6, pointerEvents: "none" }}
      >
        {children}
      </div>
      <div
        className="feature-overlay"
        style={{
          position: "absolute",
          inset: 0,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          background: "rgba(255,255,255,0.4)",
          zIndex: 10,
        }}
      >
        <Lock size={32} color="#316fd4" />
        <h4>
          {userPlan === "none"
            ? translations.subscriptionRequired
            : featureName
              ? `${translations.unlock}${featureName}`
              : translations.featureName}
        </h4>
        <p style={{ marginBottom: "15px", color: "#666" }}>
          {userPlan === "none"
            ? translations.neededPlan
            : translations.morePlan}
        </p>
        <button onClick={() => navigate("/upgrade")}>
          {translations.upgrade}
        </button>
      </div>
    </div>
  );
};

export default FeatureGate;
